import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardContent, CardActionArea} from 'views/components';
import {Typography, Stack} from 'views/components';

import {Translate} from 'views/module';

const Card = (props) => {
  const item = props.item;

  const clientRn = item.clientRn;
  const clientName = item.clientName;
  const status = item.status;

  const relationships = Object.values(item.relationships || {});
  const caregivers = Object.values(item.caregivers || {});

  return (
    <React.Fragment>
      <CardActionArea
        sx={{
          textAlign: 'left',
        }}
        to={`/client/${clientRn}`}
      >
        <CardContent>
          <Typography variant="h5" component="div">
            {clientName}
          </Typography>
          <Stack direction={'row'}>
            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
              <Translate expression={`client.ClientList.ClientStatus`} />
              <Translate expression={`client.Status.${status}.Title`} />
            </Typography>
          </Stack>
          {
            !!relationships.length && (
              <Stack direction="row" flexWrap="wrap" gap={0.5}>
                <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                  <Translate expression={`client.ClientList.Relationships`} />
                  {
                    relationships.map((relationship, index) => (
                      <React.Fragment key={index}>
                        {relationship.name}
                        {' '}
                        ({relationship.connectionType})
                        {
                          index < relationships.length - 1 && (
                            <>, </>
                          )
                        }
                      </React.Fragment>
                    ))
                  }
                </Typography>
              </Stack>
            )
          }
          {
            !!caregivers.length && (
              <Stack direction="row" flexWrap="wrap" gap={0.5}>
                <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                  <Translate expression={`client.ClientList.Caregivers`} />
                  {
                    caregivers.map((caregiver, index) => (
                      <React.Fragment key={index}>
                        {caregiver.caregiverName}
                        {
                          index < caregivers.length - 1 && (
                            <>, </>
                          )
                        }
                      </React.Fragment>
                    ))
                  }
                </Typography>
              </Stack>
            )
          }
        </CardContent>
      </CardActionArea>
    </React.Fragment>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Card));
